import React from "react";

const Settings = () => {
  return (
    <div className="profile-top-area">
      <label className="profile-label">Settings</label>
    </div>
  );
};

export default Settings;
